import Vue from "vue"
import Router from "vue-router"
// import { createRouter, createWebHistory } from "vue-router";
Vue.use(Router)
import Layout from "@/layout"
import FixedLayout from "@/layout/fixedIndex"
// import MenuGroup from "@/components/MenuGroup";
// import vehicleRouter from './modules/vehicle'
// import HomePage from "@/views/dashboard/index";
// import PartsDetail from "@/views/parts/detail/index"
import Dashboard from "@/views/dashboard/dashboard"
import HomePage from "@/views/dashboard/index"
import Tourist from "@/views/dashboard/tourist"
import Navbar from "@/components/Navbar/index"
import RightPanel from "@/components/RightPanel/index"
import FooterTop from "@/components/FooterTop/index"
import FooterCenter from "@/components/FooterCenter/index"
import FooterBottom from "@/components/FooterBottom/index"
import footerWhiteBottom from "@/components/footerWhiteBottom/index"
import Search from "@/components/Search/index"
import Main from "@/views/buyer/user/index"
import logFooterTop from "@/components/logFooterTop/index"
import {getToken} from "@/utils/auth"
// import SystemRouter from "./modules/system";
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
export const constantRoutes = [
	//   {
	//     path: "/redirect",
	//     component: Layout,
	//     hidden: true,
	//     children: [
	//       {
	// 		path: "/redirect/:path(.*)",
	// 		components:{
	// 			default:() => import("@/views/redirect/index")
	// 		}
	//         // component: () => import("@/views/redirect/index"),
	//       },
	//     ],
	//   },
	{
		path: "/redirect/:path(.*)",
		component: () => import("@/views/redirect/index"),
		hidden: true
		// children: [
		//   {
		// 	path: "/redirect/:path(.*)",
		// 	components:{
		// 		default:() => import("@/views/redirect/index")
		// 	}
		//     // component: () => import("@/views/redirect/index"),
		//   },
		// ],
	},
	{
		path: "/bingdingPhone",
		components: {
			default: () => import("@/views/wxcallback/bindingPhone.vue"),
			footerTop: FooterTop,
			footerBottom: FooterBottom
		}
	},

	{
		path: "/address",
		component: () => import("@/views/address/index")
	},
	{
		path: "/invoice",
		component: () => import("@/views/invoice/index")
	},
	{
		path: "/",
		// 你也可以在顶级路由就配置命名视图
		component: Layout,
		children: [
			{
				path: "",
				name: "dashboard",
				// porps: {
				//   search: { jump: true },
				// },
				components: {
					// default:getToken()? HomePage:Tourist,
					// default: () => {
					//   if (getToken()) {
					//     return import("@/views/dashboard/index");
					//   } else {
					//     return import("@/views/dashboard/tourist");
					//   }
					// },
					default: Dashboard,
					nav: Navbar,
					rightPanel: RightPanel,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					search: Search
				}
			},

			{
				path: "tourist",
				redirect: (to) => ({name: "dashboard"}),
				components: {
					default: Tourist,
					nav: Navbar,
					rightPanel: RightPanel,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					search: Search
				}
			},
			{
				path: "login",
				components: {
					default: () => import("@/views/login/index"),
					// component: () => import("@/views/login/index")
					footerTop: FooterTop,
					footerBottom: FooterBottom
				}
			},
			{
				path: "forgetPassword",
				components: {
					default: () => import("@/components/Login/components/forgetPassword"),
					footerTop: FooterTop,
					footerBottom: FooterBottom
				}
			},
			{
				path: "/register",
				components: {
					default: () => import("@/views/registered/account"),
					footerTop: FooterTop,
					footerBottom: FooterBottom
				}
			},

			{
				path: "/wxcallback",
				components: {
					default: () => import("@/views/wxcallback/index")
				}
			},
			{
				path: "notices",
				components: {
					default: () => import("@/views/foot/foot-legal-notices/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "convention",
				components: {
					default: () => import("@/views/foot/foot-legal-convention/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "us",
				components: {
					default: () => import("@/views/foot/foot-about-us/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "contact",
				components: {
					default: () => import("@/views/foot/foot-contact-us/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "privacy",
				components: {
					default: () => import("@/views/foot/foot-privacy-terms/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "recruitment",
				components: {
					default: () => import("@/views/foot/foot-recruitment/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "helper",
				components: {
					default: () => import("@/views/Helpcenter/index"),
					nav: Navbar,
					search: Search,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "parts-list",
				name: "parts-list",
				props: {
					nav: {className: "light"},
					search: true,
					default: true
				},
				components: {
					default: () => import("@/views/parts/list/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				},
				meta: {keepAlive: true}
			},
			{
				path: "shop-list",
				name: "shop-list",
				props: {
					nav: {className: "light"},
					search: true,
					default: true
				},
				components: {
					default: () => import("@/views/parts/list/shopList"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				},
				meta: {keepAlive: true}
			},
			// {
			//   // path: "parts-detail",
			//   // name: "parts-detail",
			//   // path: "parts-detail/:id",

			//   path: "/partMall",
			//   component: () => import("@/views/parts/list/partMall"),
			//   nav: Navbar,
			//   search: Search,
			//   footerTop: FooterTop,
			//   footerCenter: FooterCenter,
			//   footerBottom: FooterBottom,
			//   rightPanel: RightPanel,
			// },
			{
				path: "parts-detail",
				props: {
					nav: {className: "light"},
					search: true,
					default: true
				},
				components: {
					default: () => import("@/views/parts/detail/index"),
					//   default:PartsDetail,
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				},
				meta: {keepAlive: true, isBack: false} //用于判断上一个页面是哪个}
			},
			{
				path: "vehicleSource",
				name: "vehicleSource",
				props: {
					nav: {className: "light"},
					search: true,
					default: true
				},
				components: {
					default: () => import("@/views/vehicleSource/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				},
				meta: {keepAlive: true, isBack: false} //用于判断上一个页面是哪个}
			},

			{
				path: "cart",
				name: "cart",
				meta: {keepAlive: true},
				props: {
					nav: {className: "light"},
					search: {className: "bg-white"}
				},
				components: {
					default: () => import("@/views/merchant/cart/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					// rightPanel:()=>import("@/components/RightPanel/index")
					rightPanel: RightPanel
				}
			},
			{
				path: "confirm",
				name: "confirm",
				meta: {keepAlive: true},
				props: {
					nav: {className: "light"},
					search: {className: "bg-white"}
				},
				components: {
					default: () => import("@/views/merchant/confirm/index"),
					nav: Navbar,
					// search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					// rightPanel:()=>import("@/components/RightPanel/index")
					rightPanel: RightPanel
				}
			},
			// {
			// 	path: "/confirm",
			// 	name: "confirm",
			// 	component: () => import("@/views/merchant/confirm/layout"),
			// 	props: true
			// },
			{
				path: "options",
				name: "options",
				props: {
					nav: {className: "light"}
				},
				components: {
					default: () => import("@/views/options/list/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},
			{
				path: "activity",
				name: "activity",
				props: {
					nav: {className: "light"}
				},
				components: {
					default: () => import("@/views/activity/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom
					// rightPanel: RightPanel
				}
			},
			{
				path: "/badding",
				name: "badding",
				props: {
					nav: {className: "light"},
					search: true,
					default: true
				},
				components: {
					default: () => import("@/views/badding/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				},
				meta: {keepAlive: true}
			},
			{
				path: "options-details",
				props: {
					nav: {className: "light"}
				},
				components: {
					default: () => import("@/views/options/detail/index"),
					nav: Navbar,
					search: Search,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			},

			{
				path: "pay/:id",
				props: {
					default: true
				},
				components: {
					default: () => import("@/views/merchant/pay/index"),
					nav: Navbar,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel
				}
			}
		]
	},
	// {
	// 	path: "/confirm",
	// 	name: "confirm",
	// 	component: () => import("@/views/merchant/confirm/layout"),
	// 	props: true
	// },

	{
		path: "/mine",
		component: FixedLayout,
		// props: { className: "PQ" },
		props: {className: "light"},
		children: [
			{
				path: "",
				components: {
					nav: Navbar,
					footerTop: FooterTop,
					footerCenter: FooterCenter,
					footerBottom: FooterBottom,
					rightPanel: RightPanel,
					main: Main
				},

				children: [
					{
						path: "",
						props: {cur: "default"},
						component: () => import("@/views/buyer/user/components/theDefault")
						// alias: ["theDefault"],
					},
					{
						path: "carbonAccount",
						component: () =>
							import(
								"@/views/buyer/user/components/theDefault/components/carbonAccount"
							)
					},
					{
						path: "invoice",
						component: () => import("@/views/invoice/index"),
						alias: ["invoice"]
					},
					{
						path: "my-profile",
						component: () => import("@/views/buyer/user/components/my-profile")
					},
					{
						path: "akeouTaninvo",
						component: () =>
							import("@/views/buyer/user/components/akeouTaninvo")
					},
					{
						path: "capital-account",
						component: () =>
							import("@/views/buyer/user/components/capital-account")
					},
					{
						path: "main-business",
						component: () =>
							import("@/views/buyer/user/components/main-business")
					},
					{
						path: "my-adviser",
						component: () => import("@/views/buyer/user/components/my-adviser")
					},

					{
						path: "shipping-address",
						component: () => import("@/views/address/index")
					},

					{
						path: "thesystem-informs",
						component: () =>
							import("@/views/buyer/user/components/thesystem-informs")
					},
					{
						path: "security-center",
						component: () =>
							import("@/views/buyer/user/components/security-center")
					},
					{
						path: "changethePassword",
						component: () =>
							import(
								"@/views/buyer/user/components/security-center/components/changethePassword"
							)
					},
					{
						path: "real-name",
						component: () =>
							import(
								"@/views/buyer/user/components/security-center/components/real-name"
							)
					},
					{
						path: "pseudonym",
						component: () =>
							import(
								"@/views/buyer/user/components/security-center/components/pseudonym"
							)
					},
					{
						path: "ordeRlist",
						component: () => import("@/views/merchant/order/list/index")
					},
					{
						path: "ordeDetail",
						component: () => import("@/views/merchant/order/detail/index")
					},
					{
						path: "LogisticDetail",
						component: () =>
							import("@/views/merchant/order/detail/LogisticDetail")
					},
					{
						path: "certification",
						component: () => import("@/views/certification")
					}
				]
			}
		]
	},
	{
		path: "/order",
		component: FixedLayout,
		props: (route) => ({
			className: route.fullPath.includes("/order/list") ? "DD" : ""
		})
	}
]

// export const asyncRoutes = [SystemRouter];

const createRouter = () => {
	return new Router({
		mode: "history",
		scrollBehavior: () => ({y: 0}),
		routes: constantRoutes
	})
}

const router = createRouter()
// const router = createRouter({
//   history: createWebHistory(),
//   scrollBehavior: () => ({ y: 0 }),
//   routes: constantRoutes,
// });
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

// const router = createRouter()
// export function resetRouter() {
// 	const newRouter = createRouter()
// 	router.matcher = newRouter.matcher // reset router
// }
export default router
